@if (is_create()) {
  <p class="acta-tab-hint">Guarda el acta para consultar la diarización de las grabaciones.</p>
} @else {
  <app-meeting-record-diarization-readonly-panel [media_recordings]="media_recordings()" [seek_seconds]="seek_seconds()" />
}
